import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TableRow from "@material-ui/core/TableRow";
import { Icon } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

class InstancesTableItem extends Component {
    constructor(props) {
        super(props);
        this.onRemove = this.onRemove.bind(this);
        this.state = {
            notifications: props.instance.notifications
        }
        this.handleNotificationChange = this.handleNotificationChange.bind(this);
    }

    onRemove(e) {
        this.props.remove(this.props.instance.id);
    }

    handleNotificationChange = (event, props) => {
        const change = event.target.checked;
        props.instance.notifications = change;
        this.props.notificationChange(props.instance);
        this.setState({ notifications: props.instance.notifications });
      };

    render() {
        return (
            <TableRow 
                style= {
                    {
                        fontSize: '1.3rem',
                        textAlign: 'center'
                    }
                }
                key={this.props.instance.id}>
                <td>{this.props.instance.name}</td>
                <td>{this.props.instance.url}</td>
                { <td>{this.props.instance.primaryContact.name}<br />{this.props.instance.primaryContact.phone}<br />{this.props.instance.primaryContact.email}</td> }
                {(this.props.instance.wellTestDelay && this.props.instance.wellTestDelay !== 1) ? <td>{this.props.instance.wellTestDelay} days</td> : <td>{this.props.instance.wellTestDelay} day</td>}
                <td>{this.props.instance.percentageAnalysableTests}%</td>
                <td>{this.props.instance.percentageIncompleteTests}%</td>
                <td>{this.props.instance.percentageWellsRunning}% / {this.props.instance.checkPeriodTimeWellsRunning} hours</td>
                <td>{this.props.instance.percentageWellsShutdown}% / {this.props.instance.checkPeriodTimeWellsShutdown} hours</td>
                <td>{this.props.instance.percentageWellsCommsFailure}%</td>
                <td>{this.props.instance.percentageWellsCommsFailureManufacturers}%</td>
                <td>{this.props.instance.checkPeriodTimeWellUpdates} hours</td>
                <td>{this.props.instance.checkPeriodTimeInstallationUpdates} hours</td>
                <td>{this.props.instance.hasESPWells ? 'Yes' : 'No'}</td>
                <td>{this.props.instance.hasGLWells ? 'Yes' : 'No'}</td>
                <td><NotificationSwitch checked={this.state.notifications} onChange={(event) => this.handleNotificationChange(event, this.props)}  value="notifications"/></td>
                <td><Icon className="trash alternate icon" onClick={this.onRemove}></Icon><Link to={`/edit/${this.props.instance.id}`}><Icon className="edit icon"></Icon></Link></td>
            </TableRow>
        );
    }
}

export default InstancesTableItem;

const NotificationSwitch = withStyles({
    switchBase: {
      color: "#767C83",
      '&$checked': {
        color: "#97C221",
      },
      '&$checked + $track': {
        backgroundColor: "#97C221",
      },
    },
    checked: {},
    track: {},
  })(Switch);


// WEBPACK FOOTER //
// ./src/components/InstancesTableItem.js